
   window.addEventListener('message', function(event) {
    if (!event.origin.includes('threedium.co.uk') && !event.origin.includes('globe-trotter.threedium.co.uk')) return;

    const data = event.data;

    if (data && data.type === 'NYLA_ADD_TO_CART' && Array.isArray(data.data) && data.data.length > 0) {

      // Define the ID mapping (old Threedium key → real Shopify variant ID)
      const idMapping = {
        37334253076630: 42786612871363,
        37680403054742: 42786676441283,
        37333922283670: 42786596946115
        // Add more mappings here if needed, e.g.:
        // 12345678901234: 99999999999999,
      };

      // Get current selected variant ID (fallback/override if needed)
      let currentVariantId = null;
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.selectedVariantId) {
        currentVariantId = window.ShopifyAnalytics.meta.selectedVariantId;
      }

      const items = data.data.map((item, index) => {
        // Start with the key from Threedium
        let variantId = item.key;

        // Apply mapping if the key matches one of the old IDs
        // {% comment %} if (idMapping.hasOwnProperty(variantId)) {
        //   variantId = idMapping[variantId];
        //   console.log(`Mapped old ID ${item.key} → new ID ${variantId}`);
        // } {% endcomment %}

        // Optional: If length-based override still needed (you can remove if mapping covers everything)
        // if (currentVariantId !== null) {
        //   if (data.data.length === 1 && index === 0) {
        //     variantId = currentVariantId;
        //     console.log("Length 1 → using Shopify variant ID for position 0");
        //   } else if (data.data.length === 2 && index === 1) {
        //     variantId = currentVariantId;
        //     console.log("Length 2 → using Shopify variant ID for position 1");
        //   }
        // }

        const lineItem = {
          id: variantId,
          quantity: 1
        };

        // Add properties only if customAttributes is valid
        if (
          item.customAttributes &&
          Array.isArray(item.customAttributes) &&
          item.customAttributes.length > 0
        ) {
          lineItem.properties = {};
          item.customAttributes.forEach(attr => {
            if (attr.key && attr.value != null) {
              lineItem.properties[attr.key] = String(attr.value);
            }
          });
        }

        return lineItem;
      });

      // {% comment %} // Safety check: ensure all IDs look valid
      // if (items.some(item => !Number.isInteger(item.id) || item.id <= 0)) {
      //   console.error("Invalid variant ID after mapping:", items);
      //   alert("Configuration error: Invalid product variant ID.");
      //   return;
      // } {% endcomment %}

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(async response => {
        if (!response.ok) {
          const errData = await response.json().catch(() => ({}));
          console.error("Shopify rejected:", errData, "Status:", response.status);
          throw new Error(JSON.stringify(errData) || 'Cart add failed');
        }
        return response.json();
      })
      .then(result => {

        // {% comment %} HIDE POPUP {% endcomment %}
         document.querySelectorAll('.threedium-popup').forEach(el => {
          if (el.classList.contains('active')) {
            el.classList.remove('active');
            document.body.style.overflow = '';
          }
        });
        // {% comment %} HIDE POPUP {% endcomment %}

        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } })
        );

        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer?.show) drawer.show(null, true);
        }, 400);

        fetch('/cart.js')
          .then(r => r.json())
          .then(cart => {
            window.FoxTheme?.pubsub?.publish?.(
              window.FoxTheme?.pubsub?.PUB_SUB_EVENTS?.cartUpdate,
              { cart }
            );
          });
      })
      .catch(error => {
        console.error('Add failed:', error);
        // {% comment %} alert('Add to cart failed: ' + (error.message || 'Unknown error')); {% endcomment %}
      });
    } else {
      console.warn('Invalid or empty add-to-cart data:', data);
    }
  });